// extracted by mini-css-extract-plugin
export var resizer = "_fl-0";